import styled from "styled-components";

const StyledMainMenuFlower = styled.nav`
  padding: 2rem 0 2rem 37px;
  width: 100%;
  display: block;
  position: absolute;
  top: 90px;
  left: 0;
  right: 0;
  background-color: white;
  border-top: ${({theme}) => `1px solid ${theme.colors.brandDark}`};
  box-shadow: 0px 9px 15px 0px rgba(0,0,0,0.1);
  z-index: 1;

  @media (max-width: 859px) {
    display: none;
  }

  &.is-hidden {
    position: absolute !important;
    height: 1px; 
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap; /* added line */
  }

  .main_menu {
    margin-right: auto;
    margin-left: auto;
    display: grid;
    grid-gap: 20px 40px;
    
    @media (min-width: 860px) and (max-width: 1279px) {
      grid-template-columns: repeat(3, 1fr);
      max-width: 680px;
    }
    @media (min-width: 1280px) {
      grid-template-columns: repeat(5, minmax(166px, auto));
    }
  }

  .main-menu__brands {
    grid-column: span 3;
  }

  .main_menu__list-grid {
    display: grid;
    grid-gap: 0 40px;
    grid-template-columns: repeat(3, minmax(166px, 1fr));
    padding-top: 1rem;
  }

  .main_menu__list {
    display: flex;
    flex-direction: column;
    grid-gap: 0 40px;
    padding-top: 1rem;
  }
  
  .main-menu__discover{
    margin-top: 1rem;
  }

  .main_menu__heading {
    margin-bottom: .75rem;
    width: 100%;
    display: block;
    color: ${({ theme }) => theme.colors.brandDark};
  }
  .main-menu-link {
    padding-right: 32px;
    width: fit-content;
    color: ${({ theme }) => theme.colors.brandDark};
    text-decoration: none;
    transition: var(--button-transition);
    display: inline-flex;
    align-items: center;
    position: relative;
    flex-shrink: 0; // Needed for Safari //
    white-space: nowrap; // Needed for Safari //

    svg {
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-45%) rotate(90deg);
      width: 18px;
      height: 18px;
      stroke: ${({ theme }) => theme.colors.brandDark};
      transition: var(--button-transition);
    }

    &:hover,
    &:focus {
      svg {
        right: 0;
      }
    }
  }

  .main-menu-link__brands {
    @media (min-width: 860px) and (max-width: 1279px) {
      grid-area: 3/3;
    }
    @media (min-width: 1280px) {
      grid-area: 2/6;
    }
  }
`;
export default StyledMainMenuFlower;
